var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWedit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_506",
    "data-name": "Rectangle 506",
    width: 16,
    height: 16,
    transform: "translate(3 40)",
    fill: "#146ae3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_151329",
    "data-name": "Group 151329",
    transform: "translate(-3 -40)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M10.3,56H6.2a3,3,0,0,1-2.9-1.888A3.044,3.044,0,0,1,3,52.82V44.671A3.1,3.1,0,0,1,5.5,41.59a1.711,1.711,0,0,1,.7-.1h5.9a.734.734,0,0,1,.8.8.643.643,0,0,1-.6.6h-6a1.63,1.63,0,0,0-1.7,1.193c-.2.1-.2.4-.2.6V52.82a1.787,1.787,0,0,0,1.8,1.789h8.3a1.787,1.787,0,0,0,1.8-1.789V47.056a.663.663,0,0,1,.5-.7.676.676,0,0,1,.9.6V52.82A2.979,2.979,0,0,1,15.8,55.7a3.21,3.21,0,0,1-1.4.3Z",
    fill: "#146ae3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M17,40a1.922,1.922,0,0,1,1.8,1.193,1.807,1.807,0,0,1-.3,2.087,27.156,27.156,0,0,1-2.3,2.485c-1.6,1.789-3.2,3.478-4.8,5.168-.1.1-.3.2-.4.3-.8.3-1.5.7-2.3.994a1.037,1.037,0,0,1-1.2-.2,1.009,1.009,0,0,1-.2-.894c.3-.8.5-1.59.8-2.385,0-.1.1-.2.2-.3,2.3-2.584,4.7-5.068,7-7.652A2.675,2.675,0,0,1,17,40Zm-5.6,9.043c0-.1.1-.1.1-.2,1.4-1.59,2.9-3.081,4.3-4.671.5-.6,1-1.093,1.6-1.689a.555.555,0,0,0,0-.894c-.3-.3-.6-.2-.9.1a.1.1,0,0,1-.1.1c-2,2.087-3.9,4.273-5.9,6.36a.1.1,0,0,1-.1.1C10.7,48.447,11,48.745,11.4,49.043ZM9,50.733a10.121,10.121,0,0,0,1.5-.7,8.988,8.988,0,0,0-1-.894A9.721,9.721,0,0,0,9,50.733Z",
    fill: "#146ae3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWedit);
export default __webpack_public_path__ + "static/media/wedit.a5992070d0200d1e5044be9749873d58.svg";
export { ForwardRef as ReactComponent };